import { fetchPromoOffers } from './fetchPromoOffers';
import type { IGetOffersForPromoPageDesktopResponseSchema } from '../../repositories/search-offers/entities/entities/GetOffersForPromoPageDesktopResponseSchema';
import type { IPromoQuerySchema } from '../../repositories/search-offers/entities/query_for_offer_promos/PromoQuerySchema';
import { IApplicationContext } from '../../types/applicationContext';

interface IFetchRegionMetaParameters {
  path?: string;
  subdomain: string;
  query?: IPromoQuerySchema;
}

export async function fetchPromoOffersSafe(
  context: IApplicationContext,
  { path, subdomain, query }: IFetchRegionMetaParameters,
): Promise<IGetOffersForPromoPageDesktopResponseSchema | null> {
  try {
    return await fetchPromoOffers(context, { path, subdomain, query });
  } catch (e) {
    context.logger.error(e);

    return null;
  }
}
